<template>
  <div class="videoReviewInfo">
    <el-tabs v-model="activeName">
      <el-tab-pane label="待审核视频" name="unPassedVideo">
        <unPassedVideo ref="unPassedVideo" :infoId="infoId" @showDialog="showDialog" />
      </el-tab-pane>
      <el-tab-pane label="通过审核视频" name="passedVideo">
        <passedVideo ref="passedVideo" :infoId="infoId" @showDialog="showDialog" />
      </el-tab-pane>
    </el-tabs>
    <el-dialog custom-class="dailogComponents" title="查看视频" :visible.sync="visible" :destroy-on-close="true"
      :close-on-click-modal="false" v-if="visible" width="630px">
      <div style="text-align:center">
        <el-pagination background layout="prev, pager, next" :page-count="currentVideoList.length"
          :current-page="currentVideoIndex" @current-change="handleCurrentChange" />
      </div>
      <div class="video-box">
        <div class="video-btn-box">
          <i @click="btnClick(-1)" class="el-icon-arrow-left"></i>
        </div>
        <el-row type="flex" class="dialog-video-box dialogBox" justify="space-around">
          <video-player :class="getVideoClass" class="video-player vjs-custom-skin" ref="videoPlayer" @play="videoPlay"
            @ended="onPlayerEnded($event)" :playsinline="true" :options="playerOptions"
            @ready="playerIsReady"></video-player>
        </el-row>
        <div class="video-btn-box">
          <i @click="btnClick(1)" class="el-icon-arrow-right"></i>
        </div>
      </div>
      <p class="wxts">
        温馨提示：若不能正常播放，请用360极速浏览器查看视频并关闭硬件加速。
      </p>
      <div v-if="
        ($roleFilter('videoReview:return') &&
          operateType === 2 &&
          hasLock === 0) ||
        (operateType === 3 &&
          $roleFilter('videoReview:revoke') &&
          hasLock === 0)
      " class="text-box">
        <p>
          <span style="color: red">*</span>请填写<span>{{
            dialogType === 1 ? "撤销" : "退回"
          }}</span>理由，方便考生调整视频：
        </p>
        <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 4 }" placeholder="请输入" v-model="textarea">
        </el-input>
      </div>
      <div v-if="hasLock === 0" class="dialogFooter">
        <template v-if="dialogType === 1">
          <el-button v-if="$roleFilter('videoReview:revoke')" size="medium" @click="visible = false">取消</el-button>
          <Debounce>
            <el-button v-if="$roleFilter('videoReview:revoke')" size="medium" :disabled="flag || timeNumber !== 0"
              type="danger" @click="submit"><span v-if="!flag && timeNumber !== 0">{{ `(${timeNumber}s)` }}</span>
              撤销
            </el-button>
          </Debounce>
        </template>
        <template v-if="dialogType === 2">
          <el-button size="medium" v-if="operateType === 1 && $roleFilter('videoReview:return')" type="danger"
            @click="operateType = 2">退回
          </el-button>
          <el-button size="medium" v-if="operateType === 2" type="primary" @click="operateType = 1">返回</el-button>
          <template v-if="$roleFilter('videoReview:pass') && operateType === 1">
            <Debounce>
              <el-button size="medium" :disabled="timeNumber !== 0" type="primary" @click="pass"><span
                  v-if="timeNumber !== 0">{{ `(${timeNumber}s)` }}</span>通过
              </el-button>
            </Debounce>
          </template>
          <template v-if="$roleFilter('videoReview:return') && operateType === 2">
            <Debounce>
              <el-button size="medium" :disabled="timeNumber !== 0" type="danger" @click="submit"><span
                  v-if="timeNumber !== 0">{{ `(${timeNumber}s)` }}</span>退回
              </el-button>
            </Debounce>
          </template>
        </template>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import unPassedVideo from "./unPassedVideo";
import passedVideo from "./passedVideo";
import * as videojs from "video.js";
import "videojs-flash";
import "videojs-hotkeys";

export default {
  name: "videoReviewInfo",
  components: {
    unPassedVideo,
    passedVideo,
  },
  mounted () {
    let navList = this.$store.state.websetting.navBreadList;
    navList[2].title = this.$route.query.name + "查看详情";
    this.$store.commit("setNav", navList);
  },
  computed: {
    getVideoClass () {
      return ["", "videos-rotate1", "videos-rotate2", "videos-rotate3"][
        this.videoRotate
      ];
    },
    player () {
      return this.$refs.videoPlayer.player;
    },
  },
  created () {
    if (!this.$route.query.id) {
      this.$router.go(-1);
      this.$message({
        type: "warning",
        message: "id已过期,请重新查看!",
        duration: 1000,
      });
      return;
    }
    this.infoId = this.$route.query.id;
    this.hasLock = this.$route.query.hasLock * 1;
  },
  watch: {
    activeName (val) {
      this.$refs[val].tableLoad();
    },
  },
  data () {
    return {
      infoId: null,
      activeName: "unPassedVideo",
      playerOptions: {
        muted: false,
        language: "zh-CN",
        playbackRates: [0.7, 1.0, 1.5, 2.0],
        sources: [
          {
            src: "",
            type: "",
          },
        ],
        notSupportedMessage: "此视频暂无法播放，请联系管理员！",
        poster: "../../../assets/img/video.png", //你的封面地址
        controlBar: {
          timeDivider: true,
          durationDisplay: true,
          remainingTimeDisplay: false,
          fullscreenToggle: true, //全屏按钮
        },
      },
      videoRotate: 0,
      visible: false,
      videoList: [],
      videoIndex: 0,
      operateType: 0, //1通过。2退回，3撤销
      dialogType: 1, //1已经审核页面,2为审核
      textarea: "",
      timeNumber: 5,
      setInt: null,
      hasLock: 0, //是否锁定，0未锁定，1已锁定,
      flag: false,
      currentVideoList: null,
      currentVideoIndex: null,
    };
  },
  methods: {
    showDialog (index, list, type) {
      this.visible = true;
      this.timeNumber = 5;
      console.log(list);
      this.videoList = list;
      this.videoIndex = index;
      this.dialogType = type;
      this.operateType = type === 1 ? 3 : 1;
      this.currentVideoList = list[index].videoList;
      this.flag = list[index].flag ?? false; // 已评分的考生视频不能撤销
      console.log('flag', this.flag)
      this.currentVideoIndex = 1;
      let path = this.currentVideoList[this.currentVideoIndex - 1];
      this.setVideoSrc(path);
      this.$nextTick(() => {
        this.createBut();
      });
    },
    //设置视频src
    setVideoSrc (path) {
      if (this.$refs.videoPlayer) {
        this.$refs.videoPlayer.player.src(path);
      }
      let videoType = path.substring(path.lastIndexOf(".") + 1);
      if (videoType === "mp4" || videoType === "MP4") {
        this.playerOptions.sources[0].type = "video/mp4";
      } else if (videoType === "mov" || videoType === "MOV") {
        this.playerOptions.sources[0].type = "video/mp4";
      } else {
        this.playerOptions.sources[0].type = "application/x-mpegURL";
      }
      this.playerOptions.sources[0].src = path;
    },
    // 视频播完回调
    onPlayerEnded () {
      if (this.currentVideoIndex < this.currentVideoList.length) {
        this.currentVideoIndex++;
        let path = this.currentVideoList[this.currentVideoIndex - 1];
        this.setVideoSrc(path);
        setTimeout(() => {
          this.$refs.videoPlayer.player.play();
        }, 1000);
      }
    },
    //当前页改变事件
    handleCurrentChange (currentPage) {
      this.currentVideoIndex = currentPage;
      let path = this.currentVideoList[this.currentVideoIndex - 1];
      this.setVideoSrc(path);
    },
    createBut () {
      let Button = videojs.getComponent("Button");
      let myButton = videojs.extend(Button, {
        constructor: function (player, options) {
          Button.apply(this, arguments);
          this.addClass("fullscreen-enter");
        },
        handleClick: () => {
          // 绑定点击事件
          this.videoRotate = this.videoRotate == 3 ? 0 : this.videoRotate + 1;
        },
        buildCSSClass: function () {
          return "iconfont pro-icon-xuanzhuan video-player-button";
        },
      });
      //注册
      videojs.registerComponent("myButton", myButton);
      // 添加到controlBar中
      this.$refs.videoPlayer.player.getChild("controlBar").addChild("myButton");
    },
    playerIsReady (player) {
      player.hotkeys({
        volumeStep: 0.1,
        seekStep: 5,
        enableModifiersForNumbers: false,
        fullscreenKey: function (event, player) {
          // override fullscreen to trigger when pressing the F key or Ctrl+Enter
          return event.which === 70 || (event.ctrlKey && event.which === 13);
        },
      });
    },
    pass () {
      let obj = {
        refuseDetail: this.textarea,
        type: this.operateType,
        videoId: this.videoList[this.videoIndex].videoId,
      };
      this.$dailog({
        title: "通过",
        context: "是否确认通过该视频？",
        callbackFun: () => {
          this.$axios.post("/videoVerify/verify", obj).then((res) => {
            this.$message.success("成功！");
            this.visible = false;
            this.$refs[this.activeName].tableLoad();
          });
        },
      });
    },
    submit () {
      if (
        (this.operateType === 3 || this.operateType === 2) &&
        !this.textarea
      ) {
        this.$message.warning("必填项未输入！");
        return;
      }
      let obj = {
        refuseDetail: this.textarea,
        type: this.operateType,
        videoId: this.videoList[this.videoIndex].videoId,
      };

      this.$axios.post("/videoVerify/verify", obj).then((res) => {
        this.$message.success("成功！");
        this.visible = false;
        this.$refs[this.activeName].tableLoad();
        this.textarea = "";
      });
    },
    btnClick (step) {
      console.log(this.currentVideoIndex + step, 'this.currentVideoIndex + step');
      if (this.currentVideoIndex + step <= 0 || this.currentVideoIndex + step > this.currentVideoList.length) {
        this.$message.warning("无视频可播放！");
        return;
      }
      this.handleCurrentChange(this.currentVideoIndex + step);
    },
    // btnClick(type) {
    //   //type===1下一个
    //   this.timeNumber = 5;
    //   if (this.setInt) {
    //     clearInterval(this.setInt);
    //   }
    //   console.log(type, this.videoIndex, this.videoList,this.currentVideoList);
    //   if (type === 1 && this.videoIndex === this.currentVideoList.length - 1) {
    //   console.log(this.videoIndex === this.currentVideoList.length - 1,'123123');
    //     this.$message.warning("无视频可播放1！");
    //     return;
    //   }
    //   if (type === -1 && this.videoIndex === 0) {
    //     this.$message.warning("无视频可播放2！");
    //     return;
    //   }
    //   console.log(this.videoList[this.videoIndex].videoList);
    //   this.videoIndex += type;
    //   this.currentVideoList = this.videoList[this.videoIndex].videoList;
    //   this.currentVideoIndex = 1;
    //   let path = this.currentVideoList[this.currentVideoIndex - 1];
    //   this.setVideoSrc(path);
    // },
    videoPlay () {
      this.setInt = setInterval(() => {
        if (this.timeNumber === 0) {
          clearInterval(this.setInt);
        } else {
          this.timeNumber -= 1;
        }
      }, 1000);
    },
  },
};
</script>
<style lang="scss">
.wxts {
  color: #ff3e3e;
  text-align: center;
  padding: 0 40px 10px;
}

.videoReviewInfo {
  .text-box {
    padding: 10px;

    p {
      font-size: 13px;
      color: #333333;
      margin-bottom: 5px;
    }
  }

  .video-box {
    display: flex;

    .video-btn-box {
      display: flex;
      align-items: center;
      justify-content: center;

      i {
        font-size: 40px;
        font-weight: bolder;
        cursor: pointer;
        color: #409eff;
      }
    }

    .dialog-video-box {
      flex: 1;
    }
  }

  .video-player-button {
    cursor: pointer;
    margin-right: 10px;
  }

  .video-player-button {
    cursor: pointer;
    margin-right: 10px;
  }

  .video-player {
    width: 100%;

    .video-js {
      width: 100%;
      overflow: hidden;
      height: 500px;
    }
  }

  .videos-rotate1 {
    .vjs-tech {
      transform: rotateZ(-90deg);
    }
  }

  .videos-rotate2 {
    .vjs-tech {
      transform: rotateZ(-180deg);
    }
  }

  .videos-rotate3 {
    .vjs-tech {
      transform: rotateZ(-270deg);
    }
  }
}
</style>
